import { useEffect, useState } from 'react';
import { cn } from '../../lib/cn';
import { STATO_MAIL, leggiStatoMail, type StatoMail } from '../../lib/email/statoMail';

/**
 * Accanto all'email: le mail di SLAB gli arriveranno o no. Al passaggio del
 * mouse dice perche'. Se lo stato non si riesce a leggere non mostra niente:
 * meglio nessun badge che uno sbagliato.
 */
export function BadgeMail({ email }: { email: string | null | undefined }) {
  const [stato, setStato] = useState<StatoMail | null>(null);

  useEffect(() => {
    let attivo = true;
    setStato(null);
    leggiStatoMail(email).then(
      (letto) => attivo && setStato(letto),
      () => attivo && setStato(null)
    );
    return () => {
      attivo = false;
    };
  }, [email]);

  if (!stato) return null;
  const descrizione = STATO_MAIL[stato];

  return (
    <span
      title={descrizione.spiegazione}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide',
        descrizione.badge
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', descrizione.puntino)} />
      {descrizione.label}
    </span>
  );
}
